import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {ActivityTypeEnum} from '../../../api';

@Component({
    selector: 'app-activity-log-dialog',
    templateUrl: 'activity-log-dialog.component.html',
    standalone: false
})

export class ActivityLogDialogComponent implements OnInit {

  public resourceId: number;
  public activityType: ActivityTypeEnum;

  constructor(@Inject(MAT_DIALOG_DATA) public passedData: any,
              public dialogRef: MatDialogRef<ActivityLogDialogComponent>,) {
  }

  ngOnInit() {
    this.resourceId = this.passedData.resourceId;
    this.activityType = this.passedData.activityType;
  }
}
